'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialFreebsdDevil = function IoSocialFreebsdDevil(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm39.3 9c1.5 2.9 0.6 6.3-1.6 8.4s-4.7 2.6-4.7 2.6c0.2 2.5 1.3 4.6-3.2 8-3.3 2.5 0.2 7 0.2 7 0.8 1.1 1.8 1.5 2.5 2.5h-21.2s1.1-1.1-0.6-2.5c0 0-1.6-1.3-1.4-2.3s0.5-1 0.7-1.1 0-0.6 0-0.6l-1.5-1.5s-1 1-3.4 1c-3 0-5.1-3-5.1-3h3.6s-0.5 0.6-0.6 1c0 0.3 0.1 0.4 0.1 0.4s0.9 0.5 1.7 0.5c1.4 0 2.6-1 2.6-1l-1.9-1.7-1.1 0.3-1.3-2.9 3.1 0.8-0.1 1.2 2.2 1.4s0.7-0.7 0.5-2.1-0.7-2-0.7-2-0.3 0-0.7 0.3-0.4 0.4-0.4 0.4l-0.8-3.4s3.3 1.5 3.9 4.9c0.2 1.6-0.5 2.8-0.5 2.8l1.3 0.7s0.5-0.3 1.4-0.5 1.8-0.2 2.2 0.6 0.4 1 0.3 1.5 0 0.7 0.5 0.9 0.5 0.4 0.9 0.6 1.1 0.5 1.6 0.1 0.6-0.8 0.6-1.4v-1.2s-0.7-0.6-2.5-1.6-4.2-1.7-5.1-3.1-1-3.4 0-4.5c0.7-0.7 1.8-1.9 2-2.7 0.3-1.1 0.3-3.3 0.3-3.3s-0.8-1.2-0.6-3.1c0.2-2.3 1.7-6.6 7.5-8.9 0 0-3.1 4.3-1.6 6.2 0 0 2.9-0.8 6.1-0.7 2.4 0.2 4.3 1 5.7 2.2s1.9 1.8 3.6 1.4 2.2-1.4 2.2-2.6c0-1.5-1.2-4-1.2-4s2.8 0.5 4.5 4z m-24.1 6.9c1.1-0.4 1.7 0.8 1.7 0.8 1.1-1.9 2.3-4.7 1.7-5s-5 2-5.2 6.9c0 0 0.5-2.4 1.8-2.7z m2.9 1.1c0.4-0.5 2.7-0.6 2.9 1.4 0.3 2.7-1.9 4.4-1.9 4.4s0.6 0.2 1.8-0.1c1.4-0.4 3.4-2.3 3.4-5.5s-1.6-5.2-3.2-4.9-3 4.7-3 4.7z' })
        )
    );
};

exports.default = IoSocialFreebsdDevil;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-freebsd-devil.js
// module id = 2676
// module chunks = 0